import { QRWebPagePayload, QuarterlyReportWebPage } from 'commons/types/DTO/bank/quarterlyReport'
import { Request } from 'commons/utils/request'

export const getQRDetailsWebPage = (payload?: QRWebPagePayload) =>
  Request.post<QuarterlyReportWebPage>(Request.urls.bank.quarterlyAnalyticsDetailsWebpage, payload)
